module.exports = __webpack_public_path__ + "static/health-smart-behavior-year-2-body-1-111e70d02bbec5c9a5212059e0853f3d.jpg";